import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    createOrden,
    getHistorico,
    getOrdenes,
    getOrden,
    getSaldo
}

function getHistorico(query = {}) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/stp/historico`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getSaldo() {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/stp/saldo`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getOrden(ordenId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/stp/ordenes/${ordenId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getOrdenes(query = {}) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/stp/ordenes`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createOrden(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/stp/ordenes`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}
